export { BinIcon } from './bin'
